import { render, staticRenderFns } from "./TemplateDialog.vue?vue&type=template&id=1ef54282&"
import script from "./TemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./TemplateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports